import React, { useEffect } from 'react';
import { Form } from 'antd';
import Navigation from '../../Navigation/Navigation';
import { useDispatch, useSelector } from 'react-redux';
import salvaStep from '../../../redux/actions/mock/salvaStep';
import salvaStepSkipping from '../../../redux/actions/mock/salvaStep';
import * as actionTypes from '../../../redux/actions/actionTypes';
import moment from 'moment';

const FormSteps = ({
  dati,
  formId,
  children,
  bloccoAvanzamento,
  skip
}) => {

  const dispatch = useDispatch();
  const datiState = useSelector(state => state.dataReducer);
  const [form] = Form.useForm();
  const loadingStep = useSelector(state => state.dataReducer.load.loadingStep);
  const apiPath = useSelector(state => state.dataReducer.dataApiPath);
  const numPratica = datiState.modello.numPratica;

    useEffect(() => {
      form.setFieldsValue(valoriIniziali());
      console.log(`RESET VALORI`);
    },[datiState.modello.datiPratica.cittadinanza]); // eslint-disable-line


  function onFinish(values) {
    let nuoviValori = sostituisciDateSalvaStep(values);
    
    const datiFinali = {
      ...datiState.modello.datiPratica,
      ...nuoviValori
    };

    dispatch({ type: actionTypes.LOADING_TRUE });
    dispatch({ type: actionTypes.SALVA_DATI, payload: nuoviValori });

    if (skip) {
      dispatch(salvaStepSkipping(datiFinali, datiState.modello.id, datiState.modello.codiceBroker, datiState.modello.currentStep, apiPath, numPratica));
    } else {
      dispatch(salvaStep(datiFinali, datiState.modello.id, datiState.modello.codiceBroker, datiState.modello.currentStep, apiPath, numPratica));
    }
  }


    const onFinishFailed = (errorInfo) => {
    };


    function valoriIniziali(){
      let datiRicavati = {};
      const richiesta = datiState.modello.datiPratica || {};
      let nuovaRichiesta= sostituisciDate(richiesta);
        datiRicavati = Object.assign(datiRicavati,nuovaRichiesta);
      return datiRicavati;
    }


    function sostituisciDate(obj){
        let step = obj;
        let newStep = {};
        //console.log(`Vecchio step: `,step);
        Object.entries(step).forEach(([chiave,dato]) => {
          if(moment(dato,'YYYY-MM-DD',true).isValid()){
            Object.assign(newStep,{[chiave]:moment(dato,'YYYY-MM-DD')})
          }else if(moment(dato,'YYYY-MM',true).isValid()){
            Object.assign(newStep,{[chiave]:moment(dato,'YYYY-MM')})
          }else{
            Object.assign(newStep,{[chiave]:dato})
          }
        });
        //console.log(`Nuovo step: `,newStep);
    return newStep;
    }


    function sostituisciDateSalvaStep(obj){
      let step = obj;
      let newStep = {};
      Object.entries(step).forEach(([chiave,dato]) => {
        if(moment(dato,'YYYY-MM-DDTHH:mm:ssZ',true).isValid()){
          if(chiave === 'tempoResidenza' || chiave === 'dataInizioAttivita' || chiave === 'dataFineAttivita'){
            Object.assign(newStep,{[chiave]:moment(dato).format('YYYY-MM')});
          }else{
            Object.assign(newStep,{[chiave]:moment(dato).format('YYYY-MM-DD')});
          }
        }else{
          Object.assign(newStep,{[chiave]:dato});
        }
      });
  return newStep;
  }


    return(
          <>
            <Form name={formId}
            form={form}
            onFinish={onFinish}
            onFinishFailed={onFinishFailed}
            initialValues={valoriIniziali()}
            >
                {children}
                <Navigation bloccoAvanzamento={bloccoAvanzamento} loadingStep={loadingStep} skip={skip} />
            </Form>
          </>
    )
}

export default FormSteps;